import { createSlice } from '@reduxjs/toolkit';

import { changeModeratorPanelTab, changeFlaggedViewTab, changeDeletedViewTab } from './actions';
import { initialState } from './state';

export const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(changeModeratorPanelTab, (state, { payload }) => {
      state.moderatorPanel = payload;
    });
    builder.addCase(changeFlaggedViewTab, (state, { payload }) => {
      state.flaggedView = payload;
    });
    builder.addCase(changeDeletedViewTab, (state, { payload }) => {
      state.deletedView = payload;
    });
  },
});
